import { FormControl, FormGroup } from '@angular/forms';
import { LocationSummary } from 'src/app/core/models/reports/reports.model';
import { Options } from '../../../shared/report-format/report-format.constants';

export const CONSTS = {
  HEADER: $localize`Location Summary`,
  LABEL: $localize`Completed Date`,
};
export const LOCATION_REPORT_FILE_NAME = 'Location-Summary-Report';

export const LOCATION_PDF_REPORT = {
  NAME: 'Location Summary Report',
  HEADER: {
    LOCATION_CODE: 'Location Code:',
    LOCATION_NAME: 'Location Name:',
  },
  FOOTER: {
    TOTAL: 'Total'.toUpperCase() + ':',
  },
  COLUMNS: [
    'Loop'.toUpperCase(),
    'Driver'.toUpperCase(),
    'Total Stops'.toUpperCase(),
    'Total Pkgs'.toUpperCase(),
    'Delivery Stops NET'.toUpperCase(),
    'Delivery Pkgs NET'.toUpperCase(),
    'Pickup Stops NET'.toUpperCase(),
    'Pickup Pkgs NET'.toUpperCase(),
    'Missed Pickup'.toUpperCase(),
    'Missed Del Stop'.toUpperCase(),
    'Missed Del Pkgs'.toUpperCase(),
    'Send-Again COD'.toUpperCase(),
    'Send-Again Paid'.toUpperCase(),
    'Net COD'.toUpperCase(),
    'Offload'.toUpperCase(),
    'Open'.toUpperCase(),
    'Other'.toUpperCase(),
  ],
  DATA_FIELDS: [
    'loop',
    'driver',
    'totalStops',
    'totalPkgs',
    'deliveryStopsNET',
    'deliveryPkgsNET',
    'pickupStopsNET',
    'pickupPkgsNET',
    'missedPickup',
    'missedDelStop',
    'missedDelPkgs',
    'sendAgainCOD',
    'sendAgainPaid',
    'netCOD',
    'offload',
    'open',
    'other',
  ] as (keyof LocationSummary)[],
};

type LocationSummaryFormField = {
  date: FormControl<Date>;
  reportFormat: FormControl<Options>;
};

export type LocationSummaryFormGroup =
  FormGroup<LocationSummaryFormField> | null;
